import { UserType } from "./helpers/types";
import { resources } from "./resources";

interface Link {
  icon: string;
  title: string;
  url: string;
  allowedUserTypes: UserType[];
  dropdown?: any[];
}

const pageSizeStr = localStorage.getItem("VIRTUAL_CARD_SAVED_PAGE_SIZE");
const pageSize = pageSizeStr ? Number(pageSizeStr) : 10;

export const initialPaginationData = { pageSize, total: 0, pageNumber: 1 };

export const allLinks: Link[] = [
  {
    icon: resources.icons.REPORT,
    title: "Issuer Config",
    url: "/issuer-config",
    allowedUserTypes: ["VCP_ADMIN"]
  },
  {
    icon: resources.icons.REPORT,
    title: "Port Mapping",
    url: "/port-mapping",
    allowedUserTypes: ["VCP_ADMIN"]
  },
  {
    icon: resources.icons.REPORT,
    title: "Wallet",
    url: "/wallet",
    allowedUserTypes: ["VCP_ADMIN"]
  }
];

export const imageExtensions: any = {
  tiff: true,
  tif: true,
  bmp: true,
  jpg: true,
  jpeg: true,
  gif: true,
  png: true,
  eps: true
};
